import { yupResolver } from "@hookform/resolvers/yup"
import {
  Button,
  Group,
  LoadingOverlay,
  Modal,
  MultiSelect,
  Select,
  TextInput,
  Textarea,
  Tooltip,
} from "@mantine/core"
import {
  IconArchive,
  IconBrandTelegram,
  IconDeviceFloppy,
  IconRefresh,
} from "@tabler/icons-react"
import { useEffect, useState } from "react"
import { Controller, useForm } from "react-hook-form"
import { useLocation, useParams } from "react-router-dom"
// import locations from "../../../shared/utility/locations.json";
import * as Yup from "yup"
import { CollectionQuery, Order } from "../../../models/collection.model"
import {
  EntityConfig,
  entityViewMode,
} from "../../../models/entity-config.model"
import {
  CredentialType,
  Notification,
  NotificationMethod,
} from "../../../models/notification.model"
// import { ParentStatus } from "../../../models/parent.model";
import Card from "../../../shared/component/Card/card-component"
import Confirmation from "../../../shared/component/confirmation/action-confirmation"
import EntityList from "../../../shared/component/entity-list/entity-list.component"
import {
  useCreateNotificationMutation,
  useDeleteNotificationMutation,
  useLazyGetNotificationsQuery,
  useLazyGetPropertiesForNotificationQuery,
  useLazyGetUnitTypesForNotificationsQuery,
} from "../store/notification.query"

import { useTranslation } from "react-i18next"
import { useCurrentUser } from "../../../shared/hooks/current-user.hook"
import { dateFormat } from "../../../shared/utility/date-format/date-format"
import "../styles/style.css"

export default function NotificationPage() {
  const params = useParams()
  const { t } = useTranslation()
  const [userInfo, userId, ownerInfo] = useCurrentUser()
  const [selectedProperties, setSelectedProperties] = useState<string[]>([])
  const [selectedUnitTypes, setSelectedUnitTypes] = useState<string[]>([])
  const location = useLocation()
  const [openNotificationModal, setOpenNotificationModal] =
    useState<boolean>(false)

  // const [specificLocations] = useState<any>(locations);
  const [viewMode, setViewMode] = useState<entityViewMode>("list")
  const [collection, setCollection] = useState<CollectionQuery>({
    skip: 0,
    top: 10,
    orderBy: [{ field: "createdAt", direction: "desc" }],
    includes: ["accountReceiver"],
  })
  const [propertyCollection, setPropertyCollection] = useState<CollectionQuery>(
    {
      skip: 0,
      top: 100,
      orderBy: [{ field: "createdAt", direction: "desc" }],
      // includes: ["accountReceiver"],
    },
  )
  // const [showStatus, setShowStatus] = useState<boolean>(false);
  // const [showSpecificLocation, setShowSpecificLocation] =
  useState<boolean>(false)
  const currentUser: any = JSON.parse(
    localStorage.getItem("userInfo") as string,
  )

  const defaultValue = {
    title: "",
    body: "",
    type:
      currentUser?.role?.key == "owner"
        ? CredentialType.Tenant
        : CredentialType.All,
    status: null,
    method: NotificationMethod.Both,
  }

  const [getNotifications, notifications] = useLazyGetNotificationsQuery()
  const [getProperties, properties] = useLazyGetPropertiesForNotificationQuery()
  const [getUnitTypes, unitTypes] = useLazyGetUnitTypesForNotificationsQuery()
  const [createNotification, notificationResponse] =
    useCreateNotificationMutation()
  const [deleteNotification, deleteNotificationResponse] =
    useDeleteNotificationMutation()

  let schema = Yup.object()
    .shape({
      type: Yup.string()
        .typeError(t("typeValidation", { type: "string", field: t("type") }))
        .required(),
      body: Yup.string()
        .typeError(t("typeValidation", { type: "string", field: t("body") }))
        .required(),
      title: Yup.string()
        .typeError(t("typeValidation", { type: "string", field: t("title") }))
        .required(),
      method: Yup.string()
        .typeError(t("typeValidation", { type: "string", field: t("method") }))
        .required(),
      // status: Yup.string().nullable().notRequired().oneOf([
      //   ParentStatus.New,
      //   ParentStatus.Assigned,
      //   ParentStatus.PartiallyAssigned,
      //   ParentStatus.WaitingToBeAssigned,
      //   ParentStatus.Declined,
      //   ParentStatus.Agreed,
      //   ParentStatus.ContractSigned,
      // ])
    })
    .required()
  const {
    register,
    setValue,
    control,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onBlur",
  })

  useEffect(() => {
    if (currentUser?.role?.key == "superAdmin") {
      getNotifications({ ...collection })
        .unwrap()
        .then((response) => {})
    } else {
      getNotifications({
        ...collection,
        filter: [
          [{ field: "ownerId", operator: "=", value: ownerInfo?.parentOwnerId }],
        ],
      })
        .unwrap()
        .then((response) => {})
    }
  }, [collection])

  useEffect(() => {
    getUnitTypes({})
  }, [])

  useEffect(() => {
    if (userInfo?.role?.key === "owner") {
      getProperties({
        ...propertyCollection,
        filter: [
          [
            {
              field: "ownerId",
              operator: "=",
              value: ownerInfo?.parentOwnerId,
            },
          ],
        ],
      })
    } else {
      getProperties(propertyCollection)
    }
  }, [propertyCollection])

  useEffect(() => {
    if (params?.id !== undefined) {
      setViewMode("detail")
    } else {
      setViewMode("list")
    }
    if (location.pathname === "/city/archived") {
      setViewMode("detail")
    }
  }, [setViewMode, params?.id, location])

  function _parseProperties() {
    const data: { label: string; value: string }[] = []

    properties.data?.data?.map((property: any) => {
      data.push({ label: property.name, value: property.id })
    })

    return data
  }

  function _parseUnitTypes() {
    const data: {label: string; value: string}[] = [];

    unitTypes?.data?.map((type: any) => {
      data.push({label: type, value: type});
    })
    return data;
  }

  const onSubmit = async (data: any) => {


    if(selectedProperties?.length > 0) {
      data.propertyIds = selectedProperties;
    }

    if(selectedUnitTypes?.length > 0) {
      data.unitTypes = selectedUnitTypes;
    }


    createNotification(data)
      .unwrap()
      .then((response) => {
        reset(defaultValue)
        setOpenNotificationModal(false)
        // setShowStatus(false);
        // setShowSpecificLocation(false);
        reset(defaultValue)
      })
  }

  const onError = (data: any) => {}

  const data: Notification[] | undefined = notifications.data?.data
  const config: EntityConfig<Notification> = {
    primaryColumn: { key: "title", name: "Title" },
    rootUrl: "/notification",
    identity: "id",
    name: "title",
    showDetail: false,
    visibleColumn: [
      {
        key: "title",
        name: t("title"),
        render(notification) {
          return notification?.type
            ? notification.title
            : `${notification?.accountReceiver?.name} (${notification?.accountReceiver?.phoneNumber})`
        },
      },
      { key: "body", name: t("body") },
      { key: "method", name: t("method") },
      { key: "type", name: t("type") },
      {
        key: "createdAt",
        name: t("registeredAt"),
        render(value) {
          return dateFormat(value.createdAt)
        },
      },
      {
        key: "actions",
        name: t("action"),
        render: (value: Notification) => {
          return (
            <>
              <div className="flex">
                <Confirmation
                  type={"danger"}
                  message={t("permanentDeleteMessage")}
                  header={t("permanentDeleteTitle")}
                  yesText={t("delete")}
                  onYes={(reason: string) => {
                    // archiveFeedback({id: value.id, reason: reason});
                    deleteNotification(value.id ?? "")
                  }}
                >
                  <Tooltip label={t("delete")}>
                    <Button
                      variant="filled"
                      // loading={archiveResponse.isLoading}
                      className="bg-danger text-white mx-1"
                      type="button"
                      classNames={{ label: "flex space-x-1" }}
                      size={"xs"}
                    >
                      <span>
                        <IconArchive size={22} strokeWidth={1.5} />
                      </span>
                    </Button>
                  </Tooltip>
                </Confirmation>

                <Tooltip label={t("resendNotification")}>
                  <Button
                    variant="filled"
                    // loading={archiveResponse.isLoading}
                    className="bg-primary text-white mx-1"
                    type="button"
                    onClick={() => {
                      setOpenNotificationModal(true)
                      // value.type === CredentialType.Parent
                      //   ? setShowStatus(true)
                      //   : setShowStatus(false);

                      // value.type === CredentialType.Driver
                      //   ? setShowSpecificLocation(true)
                      //   : setShowSpecificLocation(false);
                      setValue("title", value.title as string)
                      setValue("body", value.body as string)
                      setValue("type", value.type as string)
                      // setValue("status", value.status);
                      // setValue("driverLocation", value.driverLocation);
                      setValue("method", value.method as string)
                    }}
                    classNames={{ label: "flex space-x-1" }}
                    size={"xs"}
                  >
                    <span>
                      <IconRefresh size={22} strokeWidth={1.5} />
                    </span>
                  </Button>
                </Tooltip>
              </div>
            </>
          )
        },
      },
    ],
    // filter: [
    //   [
    //     {
    //       field: "type",
    //       value: CredentialType.All,
    //       operator: "=",
    //       name: "All",
    //     },
    //     {
    //       field: "type",
    //       value: CredentialType.Driver,
    //       operator: "=",
    //       name: "Driver",
    //     },
    //     {
    //       field: "type",
    //       value: CredentialType.Owner,
    //       operator: "=",
    //       name: "Parent",
    //     },
    //     {
    //       field: "type",
    //       value: CredentialType.Passenger,
    //       operator: "=",
    //       name: "Passenger",
    //     },
    //   ],
    // ],
  }

  return (
    <main className="max-w-7xl mx-auto py-6 px-4 lg:px-8 mt-16">
      <LoadingOverlay visible={notifications.isFetching} />
      {/* <motion.div
                    className='grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4 mb-8'
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 1 }}
                >

                    <StatCard name='Total Products' icon={Package} value='$12,345' color='#6366F1' />
                    <StatCard name='Top Selling' icon={TrendingUp} value='1,234' color='#8B5CF6' />
                    <StatCard name='Low Stock' icon={AlertTriangle} value='567' color='#EC4899' />
                    <StatCard name='Total Revenue' icon={DollarSign} value='12.5%' color='#10B981' />

                </motion.div> */}
      <Card
        title={t("notification", { count: 2 })}
        action={
          <>
            <div className="p-3">
              <Group position="apart">
                {/* <h1>Notifications</h1> */}

                <Button
                  classNames={{ label: "flex space-x-1 " }}
                  variant="default"
                  className="bg-primary text-white"
                  type="button"
                  size="xs"
                  onClick={() => {
                    setOpenNotificationModal(true)
                    reset(defaultValue)
                  }}
                >
                  <IconBrandTelegram />
                  <span>{t("sendNotification")}</span>
                </Button>
              </Group>
            </div>
          </>
        }
      >
        <EntityList
          viewMode={viewMode}
          title={t("notification", { count: 3 })}
          header={<></>}
          total={notifications?.data?.count}
          itemsLoading={notifications.isFetching}
          showNewButton={false}
          showExport={false}
          showArchivedCheckBox={false}
          showSelector={false}
          config={config}
          items={data}
          initialPage={1}
          defaultPageSize={10}
          pageSize={[10, 15, 20]}
          collectionQuery={collection}
          onArchivedChecked={(e) =>
            setCollection({
              ...collection,
              withArchived: e,
            })
          }
          onPaginationChange={(skip: number, top: number) => {
            if (collection.skip !== skip || collection.top !== top) {
              setCollection({ ...collection, skip: skip, top: top })
            }
          }}
          onSearch={(data: any) => {
            setCollection({
              ...collection,
              search: data,
              searchFrom: ["title"],
            })
          }}
          onFilterChange={(data: any) => {
            if (collection?.filter || data.length > 0) {
              setCollection({ ...collection, filter: data })
            }
          }}
          onOrder={(data: Order) =>
            setCollection({ ...collection, orderBy: [data] })
          }
        />
      </Card>

      <Modal
        opened={openNotificationModal}
        onClose={() => {
          setOpenNotificationModal(false)
          // setShowStatus(false);
          // setShowSpecificLocation(false);
          reset(defaultValue)
        }}
        // className="my-modal-content"
        withCloseButton={false}
        title={t("notification", { count: 1 })}
        padding={20}
        size={"md"}
      >
        <form onSubmit={handleSubmit(onSubmit, onError)} className={"mt-2"}>
          <div className="w-full">
            <div className="flex w-full space-x-4  justify-center">
              <Controller
                render={({ field }) => (
                  <Select
                    radius={"xs"}
                    classNames={{ label: "dark:text-white" }}
                    className="w-full"
                    error={errors?.method && `${errors?.method?.message}`}
                    label={t("method")}
                    placeholder={t("method")}
                    data={[
                      { label: t("both"), value: NotificationMethod.Both },
                      {
                        label: t("notification", { count: 1 }),
                        value: NotificationMethod.Notification,
                      },
                      { label: t("sms"), value: NotificationMethod.Sms },
                    ]}
                    withAsterisk
                    {...field}
                  />
                )}
                name="method"
                control={control}
              />
              <TextInput
                classNames={{ label: "dark:text-white" }}
                className="w-full "
                error={errors.title && `${errors?.title?.message}`}
                withAsterisk
                label={t("title")}
                placeholder={t("title")}
                {...register("title")}
              />
            </div>

            <div className="flex w-full space-x-4  justify-center">
              <MultiSelect
                radius={"xs"}
                classNames={{ label: "dark:text-white" }}
                className="w-full"
                clearable
                // error={errors?.method && `${errors?.method?.message}`}
                label={t("property", { count: 2 })}
                placeholder={t("property", { count: 2 })}
                data={_parseProperties()}
                // withAsterisk
                value={selectedProperties}
                onChange={(value) => setSelectedProperties(value)}

                // {...field}
              />
            </div>
            <div className="flex w-full space-x-4  justify-center">
              <MultiSelect
                radius={"xs"}
                classNames={{ label: "dark:text-white" }}
                className="w-full"
                clearable
                dropdownPosition="bottom"
                // error={errors?.method && `${errors?.method?.message}`}
                label={"Unit Types"}
                placeholder={"Unit Types"}
                data={_parseUnitTypes()}
                // withAsterisk
                value={selectedUnitTypes}
                onChange={(value) => setSelectedUnitTypes(value)}

                // {...field}
              />
            </div>
            <div className="flex w-full space-x-4  justify-center">
              <Textarea
                placeholder={t("body")}
                label={t("body")}
                className="w-full"
                withAsterisk
                error={errors?.body && `${errors?.body?.message}`}
                {...register("body")}
              />
            </div>
          </div>
          <Group position="right" mt="xl">
            <>
              <Button
                classNames={{ label: "flex space-x-1 " }}
                variant="default"
                className="dark:text-white hover:bg-primary hover:dark:bg_dark_primary hover:text-white"
                type="reset"
                onClick={() => reset(defaultValue)}
                size="xs"
              >
                <span>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="fill-current h-6"
                    viewBox="0 0 32 32"
                  >
                    <path d="M18.90625 4.09375C18.101563 4.09375 17.265625 4.367188 16.625 4.9375L16.625 4.96875L16.59375 5L4.90625 16.59375C3.695313 17.804688 3.703125 19.777344 4.84375 21.0625L4.875 21.09375L4.90625 21.09375L10.90625 27.09375C11.511719 27.699219 12.320313 27.992188 13.125 28L28 28L28 26L16.5 26L27 15.5C28.265625 14.234375 28.304688 12.210938 27.09375 11L21.09375 5C20.488281 4.394531 19.710938 4.09375 18.90625 4.09375 Z M 18.875 6.125C19.195313 6.125 19.492188 6.210938 19.6875 6.40625L25.6875 12.40625C26.074219 12.792969 26.128906 13.558594 25.59375 14.09375L20.5625 19.125L12.90625 11.46875L17.96875 6.4375L18 6.40625C18.253906 6.195313 18.570313 6.125 18.875 6.125 Z M 11.46875 12.90625L19.125 20.5625L14.03125 25.65625C14.019531 25.664063 14.011719 25.679688 14 25.6875C13.484375 26.117188 12.691406 26.066406 12.3125 25.6875L6.34375 19.75C6.328125 19.730469 6.328125 19.707031 6.3125 19.6875C5.902344 19.171875 5.9375 18.375 6.3125 18Z" />
                  </svg>
                </span>
                <span>{t("reset")}</span>
              </Button>
              <Button
                variant="filled"
                className="bg-primary text-white"
                type="submit"
                classNames={{ label: "flex space-x-1" }}
                size={"xs"}
                loading={notificationResponse.isLoading}
              >
                <span>
                  <IconDeviceFloppy size={22} strokeWidth={1.5} />
                </span>
                <span>{t("submit")}</span>
              </Button>
            </>
          </Group>
        </form>
      </Modal>
    </main>
  )
}
